import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FaIcon as Fa } from "lib/FaIcon";
import { CopyTextModal } from "../../pages/copyText/CopyTextModal";
import { ShareContextMenu } from "./ShareContextMenu";
import "./shareButton.css";
import { _t, isEn } from "../../app/i18n/i18n";
import { DownloadPdfPopout } from "./DownloadPdfPopout";
import { formatDateDDMMMYY } from "../../lib/dateUtils";

const filenameRegex = /^[a-zA-Z0-9 ()\-_]{1,255}$/;

function validateFilename(name) {
  return filenameRegex.test(name);
}
export function ShareButton({ publication, customClass }) {
  const dispatch = useDispatch();

  const [modalShow, setModalShow] = useState(false);

  const [overlayShow, setOverlayShow] = useState(null);

  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const initialName = getInitialFileName();
  const [filename, setFilename] = useState(initialName);
  const filenameValidationMessage = "Please provide a valid filename, special character are not allowed.";
  const [error, setError] = useState(validateFilename(initialName) ? "" : _t(filenameValidationMessage));

  const handleHideHandler = useCallback(() => {
    setOverlayShow(false);
  }, []);
  function getInitialFileName() {
    if (isEn() && Array.isArray(publication.periodicals) && publication.periodicals.length > 0) {
      const match = publication.periodicals.find((p) => p.en && p.en.toLowerCase().includes("securitized products"));
      return match
        ? `${match.en} - ${formatDateDDMMMYY(publication.publicationDate)}`
        : `${publication.id} - ${formatDateDDMMMYY(publication.publicationDate)}`;
    }
    return `${publication.id} - ${formatDateDDMMMYY(publication.publicationDate)}`;
  }

  const handleSavePdfClick = () => {
    const newName = getInitialFileName();
    setFilename(newName);
    setError(validateFilename(newName) ? "" : _t(filenameValidationMessage));
    setOverlayShow(false);
    setShowDownloadModal(true);
  };

  const handleFilenameChange = (e) => {
    const { value } = e.target;
    setError(validateFilename(value) ? "" : _t(filenameValidationMessage));
    setFilename(value);
  };

  const handleSubmit = () => {
    if (!filename || error) return;
    const encodedFilename = encodeURIComponent(`${filename}.pdf`);
    const downloadUrl = `${publication.pdfUrl}&download=true&filename=${encodedFilename}`;
    window.open(downloadUrl, "_self", "noopener,noreferrer");
    setShowDownloadModal(false);
  };

  const onCopytextButtonClick = async () => {
    setModalShow(true);
  };

  return (
    <>
      <OverlayTrigger
        rootClose
        trigger="click"
        show={overlayShow}
        placement="auto-end"
        onToggle={setOverlayShow}
        overlay={
          <Popover id="popover-positioned-left" className="share-button">
            <Popover.Title>Publication options</Popover.Title>
            <Popover.Content className="p-0">
              <ShareContextMenu
                dispatch={dispatch}
                publication={publication}
                handleHide={handleHideHandler}
                onCopytextButtonClick={onCopytextButtonClick}
                onDownloadPdfClick={handleSavePdfClick}
              />
            </Popover.Content>
          </Popover>
        }
      >
        <Fa icon="fas fa-ellipsis-v" className={`mr-0 float-right cursor-pointer pt-2 ${customClass}`} />
      </OverlayTrigger>
      {modalShow && <CopyTextModal modalShow={modalShow} setModalShow={setModalShow} publication={publication} />}

      <DownloadPdfPopout
        show={showDownloadModal}
        filename={filename}
        error={error}
        onFilenameChange={handleFilenameChange}
        onCancel={() => {
          setShowDownloadModal(false);
          setFilename("");
          setError("");
        }}
        onSubmit={handleSubmit}
      />
    </>
  );
}
